import { amountAsCurrency } from "currency";
import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import CartInfo from "./CartInfo";
import DiscountInfo from "./DiscountInfo";
import FulfillmentInfo from "./FulfillmentInfo";
import MarkAsPaidInfo from "./MarkAsPaidInfo";
import PaymentInfo from "./PaymentInfo";
import Row from "./Row";
import { TransactionDetails } from "../../../types";
import ActionButton from "../../ActionButton";
import CardText from "../../CardText";
import StatusLabel from "../../StatusLabel";
import TransactionCard from "../../TransactionCard";

type Props = {
  payment: TransactionDetails["payment"];
};

export default function PaymentCard({ payment }: Props) {
  const tailwind = useTailwind();

  const {
    status,
    saleTotal,
    currency,
    paymentInfo,
    cartInfo,
    discountInfo,
    fulfillmentInfo,
    availableActions,
  } = payment;

  const totalAmount = amountAsCurrency({ amount: saleTotal, currency });

  return (
    <TransactionCard>
      <Row>
        <CardText.Title text="Pago" />
        <StatusLabel {...status} />
      </Row>

      <PaymentInfo
        paymentInfo={paymentInfo}
        action={availableActions.resendPaymentRequestUrl}
      />
      <MarkAsPaidInfo action={availableActions.markAsPaid} />
      <CartInfo cartInfo={cartInfo} />
      <DiscountInfo discountInfo={discountInfo} />
      <FulfillmentInfo fulfillmentInfo={fulfillmentInfo} />

      <Row style={tailwind("mt-4")}>
        <CardText.Title text="Total" />
        <CardText.Title text={totalAmount} />
      </Row>

      <View style={tailwind("items-end")}>
        <ActionButton
          action={availableActions.resendPaymentInstructions}
          style={tailwind("mt-4")}
        />
        <ActionButton
          action={availableActions.cancelPayment}
          style={tailwind("mt-4")}
        />
        <ActionButton
          action={availableActions.resendReceipt}
          style={tailwind("mt-4")}
        />
      </View>
    </TransactionCard>
  );
}
